/* eslint-disable no-magic-numbers */
/* eslint-disable operator-assignment */
/* eslint-disable no-bitwise */
/* eslint-disable eqeqeq */
/* eslint-disable fp/no-let */
/* eslint-disable max-len */
// /**
//  * YEBOYEBO Google Tag Manager compatibility for ScandiPWA
//  * @copyright Yeboyebo, Inc. All rights reserved.
//  */
import ReactPixel from 'react-facebook-pixel';

function stringToHash(string) {
    let hash = 0;

    if (string.length == 0) {
        return hash;
    }

    for (let i = 0; i < string.length; i++) {
        const char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }

    return String(hash);
}

// eslint-disable-next-line no-unused-vars
function generateEventId(eName) {
    const uCookie = document.cookie;
    const uHash = stringToHash(uCookie);
    const url = window.location.href;
    const urlHash = stringToHash(url);

    function getTimeStamp() {
        if (!Date.now) {
            Date.now = () => {
                new Date().getTime();
            };
        }

        return Date.now();
    }

    const timestamp = String(getTimeStamp());

    return eName + uHash + urlHash + timestamp;
}

// Función para obtener el valor de una cookie por su nombre
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }

    return null;// Si no existe la cookie, retorna null
}

const facebookPixelAddToCartEventProduct = (args, callback, instance) => {
    const { fbq } = window;

    if (fbq && window.localStorage.config !== undefined) {
        const localStorageConfig = JSON.parse(window.localStorage.config);
        const { product: currentProduct } = instance.props;
        const currencyCode = localStorageConfig.data.currency.base_currency_code;
        const pixelArgs = {
            currency: currencyCode,
            value: currentProduct.price_range.minimum_price.final_price.value,
            content_type: 'product',
            content_ids: [currentProduct.sku],
            contents: [
                {
                    id: currentProduct.sku,
                    quantity: 1,
                    item_price: currentProduct.price_range.minimum_price.final_price.value
                }
            ]
        };

        // const eventID = generateEventId('AddToCart');
        const eventID = `AddToCart-${currentProduct.sku.split('-')[0]}-${getCookie('_fbp')}`;

        ReactPixel.fbq('track', 'AddToCart', pixelArgs, { eventID });
    }

    return callback(...args);
};

export default {
    'Component/Product/Container': {
        'member-function': {
            addToCart: facebookPixelAddToCartEventProduct
        }
    }
};
